import { Popover } from '@mui/material';
import { defineds } from 'constants/ui.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { DateRangePicker, createStaticRanges } from 'react-date-range';
import { getMobile } from 'state/reducers/ui.reducers';
import { CustomDateRangePicker } from 'theme/elements/Inputs';
import { selectLanguage, selectTranslations } from 'state/reducers/translation.reducers';
import { enUS, he } from 'date-fns/locale';

interface Props {
  id: any;
  showCalender: boolean;
  anchorEl: any;
  state: any;
  handleClose: any;
  onChange: any;
}

export default function DateRangePopover(props: Props) {
  const lang = useAppSelector(selectLanguage);
  const t = useAppSelector(selectTranslations);
  const balancesReportMaxDate = new Date();
  balancesReportMaxDate.setDate(balancesReportMaxDate.getDate() - 1);

  const sideBarOptions = () => {
    const customDateObjects = [
      {
        label: t('components.date_range_picker.shortcuts.last_year'),
        range: () => ({
          startDate: defineds.startOfLast365Day,
          endDate: defineds.endOfToday,
        }),
      },
      {
        label: t('components.date_range_picker.shortcuts.last_quarter'),
        range: () => ({
          startDate: defineds.startOfLastNinetyDay,
          endDate: defineds.endOfToday,
        }),
      },
      {
        label: t('components.date_range_picker.shortcuts.last_month'),
        range: () => ({
          startDate: defineds.startOfLastThirtyDay,
          endDate: defineds.endOfToday,
        }),
      },
      {
        label: t('components.date_range_picker.shortcuts.last_week'),
        range: () => ({
          startDate: defineds.startOfLastSevenDay,
          endDate: defineds.endOfToday,
        }),
      },
      {
        label: t('components.date_range_picker.shortcuts.today'),
        range: () => ({
          startDate: defineds.startOfToday,
          endDate: defineds.endOfToday,
        }),
      },
    ];

    return customDateObjects;
  };

  const sideBar = sideBarOptions();
  const staticRanges = [
    // ...defaultStaticRanges,
    ...createStaticRanges(sideBar),
  ];
  const isMobile = useAppSelector(getMobile);

  const balancesReportState = props.state.map((item: any) => {
    if (item.companyStartDate) {
      const companyStartDate = item.companyStartDate.substring(0, 10);
      return {
        companyStartDate: companyStartDate,
        startDate: item.startDate,
        endDate: null,
        key: 'selection',
      };
    }
  });

  return (
    <Popover
      id={props.id}
      open={props.showCalender}
      anchorEl={props.anchorEl}
      onClose={props.handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <CustomDateRangePicker ismobile={Boolean(isMobile)} lang={lang} isBalancesReport={props.state[0]?.companyStartDate}>
        <DateRangePicker
          minDate={props.state[0]?.companyStartDate ? new Date(props.state[0]?.companyStartDate) : undefined}
          maxDate={props.state[0]?.companyStartDate ? balancesReportMaxDate : new Date()}
          ranges={props.state[0]?.companyStartDate ? balancesReportState : props.state}
          onChange={(item) => {
            props.onChange(item);
          }}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={props.state[0]?.companyStartDate ? 1 : 2}
          direction={isMobile ? 'vertical' : 'horizontal'}
          staticRanges={staticRanges}
          locale={lang === 'he' ? he : enUS}
          weekdayDisplayFormat={lang === 'he' ? 'EEEEE' : undefined}
        />
      </CustomDateRangePicker>
    </Popover>
  );
}
